// extracted by mini-css-extract-plugin
module.exports = {"author-container":"Author_author-container__jXzDT","avatar":"Author_avatar__jg453","date":"Author_date__Y8D9f"};